
export function ADD_SELECT_USER(data){
    return({type:'ADD_SELECT_USER',data});
}

export function REMOVE_SELECT_USER(data){
    return({type:'REMOVE_SELECT_USER',data});
}